export { default as DeviceGoogleLogin } from "./DeviceGoogleLogin";



// WEBPACK FOOTER //
// ./src/modules/login/components/deviceGoogleLogin/index.js